export default __webpack_public_path__ + "static/media/Haplotype.a188cd1c.svg";